// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3ed269ee","161":"9eb3c683","440":"064e0b1d","453":"938cb34f","487":"d4e92eb7","495":"c2a65760","538":"71e5beb0","606":"b7a36276","624":"fd140a7a","756":"324a3e86","770":"01d63ce7","825":"9e189e85","939":"90f435db"}[chunkId] + ".chunk.js";
};